import { isWithinRoute } from '@/utils/urls';

// check for other pages that we dont want the modal to pop on
const pagesToSkip = ['/console', '/checkout', '/checkoutATG'];
const checkForSkippablePage = (path: string = '') => {
    const lowerCasePath = typeof path === 'string' ? path.toLowerCase() : '';
    return pagesToSkip.some((page) => isWithinRoute(lowerCasePath, page.toLowerCase()));
};

export default checkForSkippablePage;
